<template>
  <div
    class="hidden"
    v-if="readyToRender"
    >
    <GlobalJs
      :widgetsData="widgetsData"
      :widgetsComputed="widgetsComputed"
      />
    <ScopedJs
      :widgetsData="widgetsData"
      :widgetsComputed="widgetsComputed"
      />
  </div>
</template>

<script>
// components
import GlobalJs from './globalCodeRenderer'
import ScopedJs from './scopedCodeRenderer'



let $ = window.$

export default {
  props: [
    'customCode',
    'scope',
    'widgetsData',
    'widgetsComputed'
  ],
  components: {
    GlobalJs,
    ScopedJs
  },
  data () {
    return {
      readyToRender: false
    }
  },
  watch: {
    customCode () {
      this.dismountCss()
      this.fillGlobalJs()
      this.fillScopedJs()
      this.fillCss()
    },
    scope () {
      this.dismountCss()
      this.fillScopedJs()
      this.fillCss()
    }
  },
  methods: {
    fillGlobalJs () {
      let jsCode = ''

      if (this.customCode.js) {
        let js = this.customCode.js
        for (let key in js) {
          if (js[key].scope) continue

          jsCode += js[key].code + '\n'
        }
      }

      let jsCodeToRender = `
        <script>
          try {
            ${jsCode}
          } catch (err) {
            throw err
          }
        <\/script>` // eslint-disable-line

      this.$store.commit('setCustomJs', { code: jsCodeToRender })
    },
    fillScopedJs () {
      let jsCode = ''

      if (this.customCode.js) {
        let js = this.customCode.js
        for (let key in js) {
          if (!js[key].scope || js[key].scope !== this.scope) continue

          jsCode += js[key].code + '\n'
        }
      }

      let jsCodeToRender = `
        <script>
          try {
            ${jsCode}
          } catch (err) {
            throw err
          }
        <\/script>` // eslint-disable-line

      this.$store.commit('setCustomJs', { scoped: true, code: jsCodeToRender })
    },
    fillCss () {
      let cssCode = ''

      if (this.customCode.css) {
        let css = this.customCode.css
        for (let key in css) {
          if (css[key].scope) continue

          cssCode += css[key].code + '\n'
        }
      }

      if (this.customCode.css) {
        let css = this.customCode.css
        for (let key in css) {
          if (!css[key].scope || css[key].scope !== this.scope) continue

          cssCode += css[key].code + '\n'
        }
      }

      $('body').append(`<style class="customCssCode">${cssCode}</style>`)
    },
    dismountCss () {
      $('.customCssCode').remove()
    }
  },
  created () {
    this.fillGlobalJs()
    this.fillScopedJs()
    this.fillCss()
    this.readyToRender = true
  },
  beforeDestroy () {
    this.$store.commit('setCustomJs', { scoped: true, code: '' })
    this.$store.commit('setCustomJs', { code: '' })
    this.dismountCss()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CustomCodeRender/index.vue